<base-support-modal [title]="title" [btnOkClass]="'btn-warning'" [btnOkLabel]="'Установить'" (onOk)="ok()" >
	<div class="form-group">
		<label>Выберите язык</label>
		<select class="form-control" [(ngModel)]="newLang" required>
			<option value="ru">Русский - ru</option>
			<option value="en">English - en</option>
			<option value="ro">Romanian - ro</option>
			<option value="pt-BR">Portuguese - pt-BR</option>
			<option value="pl">Polski - pl</option>
			<option value="tr">Türkçe - tr</option>
		</select>
	</div>
</base-support-modal>

